import { memo, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { GrCircleInformation } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../../../../../../app/common-components/ButtonComponent";
import Input from "../../../../../../app/common-components/form/input";
import CompleteTableData from "../../../../../../app/common-components/Table/CompleteTableData";
import {
  saveSeveritySLAConfig,
  SeveritySLAConfigList,
} from "../../ToolsSlice";
import CustomModal from "../../../../../../app/common-components/CustomModal";
import CustomSelectDropDown from "../../../../../../app/common-components/CustomSelectDropDown";
import { Spinners } from "../../../../../..";
import { getSortingValues } from "../../../../../../app/Constants";
import { useCommonAlert } from "../../../../../../app/utilities/helpers";

const defaultTable = () => {
  const dispatch = useDispatch();
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const { saveSeveritySLAConfigLoading } =
    useSelector((state) => state.toolsApi);
  const [state, setState] = useState({
    loading: false,
    tableData: [],
    totalCount: 0,
    addBodyOpenInfo: false,
    addBodyOpenAdd: false,

    pageNo: 0,
    pageLimit: 10,
    searchKey: "",
    sortByColumn: "",
    sortingOrder: "",
    appCriticalityOption: [
      { label: "CAT-1", value: "CAT-1" },
      { label: "CAT-2", value: "CAT-2" },
      { label: "CAT-3", value: "CAT-3" },
      { label: "CAT-4", value: "CAT-4" },
    ],
  });
  const getPayload = ({
    key = "",
    sortByColumn = "",
    sortOrder = "",
  } = {}) => ({
    keyword: key,
    sortByColumn: sortByColumn,
    sortOrder: sortOrder,
  });

  useEffect(() => {
    loadData(0, 10, getPayload());
  }, []);

  const columns = [
    {
      Header: "App Criticality",
      accessor: "appCriticality",
      className: "text-start",
      tdClassName: "text-center",
    },
    {
      Header: "Critical",
      accessor: "critical",
      tdClassName: "text-center",
      Cell: ({ value }) => <>{value ? value + " days" : "-"}</>,
    },
    {
      Header: "High",
      accessor: "high",
      tdClassName: "text-center",
      Cell: ({ value }) => <>{value ? value + " days" : "-"}</>,
    },
    {
      Header: "Medium",
      accessor: "medium",
      tdClassName: "text-center",
      Cell: ({ value }) => <>{value ? value + " days" : "-"}</>,
    },
    {
      Header: "Low",
      accessor: "low",
      tdClassName: "text-center",
      Cell: ({ value }) => <>{value ? value + " days" : "-"}</>,
    },
    {
      Header: "Actions",
      accessor: "Action",
      thClassName: "actions",
      tdClassName: "text-center",
      disableSortBy: true,
      
      Cell: (row) => (
        <div className="action-table">
          <div>
            <FiEdit className="iconStyleActions"
              onClick={() => addAddBodyOpen(row?.row?.original)}
              data-testid="editButton" title="Edit" style={{ cursor: 'pointer', width: '20px', height: '20px' }} />
          </div>
          <div>
            <FaInfoCircle className="iconStyleActions"
              onClick={() => addInfoBodyOpen(row?.row?.original)}
              data-testid="infoButton" title="Info"
              style={{ cursor: 'pointer', width: '20px', height: '20px' }} />
          </div>
        </div>
      ),
    },
  ];
  const loadData = async (pageNumber, itemPerPage, payload) => {
    setState((s) => ({ ...s, loading: true }));

    try {
      const response = await dispatch(
        SeveritySLAConfigList({
          pageNumber: pageNumber,
          itemsPerPage: itemPerPage,
          payload: payload,
        })
      ).unwrap();

      setState((s) => ({
        ...s,
        tableData: response.data || [],
        totalCount: response.totalCount || 0,
      }));
    } catch (err) {
      console.error("API failed:", err);
      // Optional: store an error message
      setState((s) => ({ ...s, error: err }));
    } finally {
      // Always runs — even on 500, 404, 400, or an unexpected cosmic sneeze
      setState((s) => ({ ...s, loading: false }));
    }
  };
  const handlePageNoChange = (pageNo) => {
    setState((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
    loadData(pageNo, state.pageLimit, getPayload());
  };
  const handlePageLimitChange = (pageLimit) => {
    setState((prev) => ({
      ...prev,
      pageLimit: pageLimit,
    }));
    loadData(state.pageNo, pageLimit, getPayload());
  };
  const onSearch = (searchKey) => {
    setState((prev) => ({
      ...prev,
      searchKey: searchKey,
    }));
    loadData(state.pageNo, state.pageLimit, getPayload({ key: searchKey }));
  };

  const handleOnSorting = (column, headerSortingState) => {
    const { sortingField, isDataSorted } = getSortingValues(
      columns,
      column,
      headerSortingState
    );
    setState((prev) => ({
      ...prev,
      sortByColumn: sortingField,
      sortingOrder: isDataSorted,
    }));
    loadData(
      state.pageNo,
      state.pageLimit,
      getPayload({
        key: state.searchKey,
        sortByColumn: sortingField,
        sortOrder: isDataSorted,
      })
    );
  };


  const { loading, tableData, totalCount } = state;

  // Reusable input with "Days" label
  const FieldWithDays = ({ label, name, value, onChange, error }) => {
    return (
      <div className="d-flex align-items-center w-100">
        <span className="w-50 me-2">
          <Input
            label={label}
            type="number"
            name={name}
            id={name}
            value={value || ""}
            error={error}
            errorMessage={
              error ? (
                <div className="informationIconStyle">
                  <div className="AppConfigTooltip">
                    <GrCircleInformation />
                    <span className="AppConfigtooltiptext p-1">
                      {`${label} should not be empty`}
                    </span>
                  </div>
                </div>
              ) : (
                ""
              )
            }
            containerClassName="frmgroup default-input"
            onChange={(e) => onChange(name, e.target.value)}
          />
        </span>
        <span> Days</span>
      </div>
    );
  };
  const SeveritySLAForm = ({ state, setState }) => {
    // Form state for add/edit
    const [formState, setFormState] = useState({
      appCriticality: state?.appCriticalityOption?.[0]?.value,
      critical: "",
      high: "",
      medium: "",
      low: "",
      id: 0,
      error: false,
    });
    // Initialize formState when modelRowData changes (edit mode)
    useEffect(() => {
      if (state?.modelRowData) {
        setFormState({
          appCriticality:
            state?.modelRowData?.appCriticality ||
            state?.appCriticalityOption?.[0]?.value,
          critical: state?.modelRowData?.critical || "",
          high: state?.modelRowData?.high || "",
          medium: state?.modelRowData?.medium || "",
          low: state?.modelRowData?.low || "",
          id: state?.modelRowData?.id || 0,
        });
      }
    }, [state?.modelRowData]);
    const handleSave = () => {
      const isCriticalEmpty = formState.critical === "";
      const isHighEmpty = formState.high === "";
      const isMediumEmpty = formState.medium === "";
      const isLowEmpty = formState.low === "";

      const hasError =
        isCriticalEmpty || isHighEmpty || isMediumEmpty || isLowEmpty;

      setFormState((s) => ({
        ...s,
        error: hasError,
      }));

      if (!hasError) {
        const savePayload = {
          appCriticality: formState.appCriticality,
          critical: formState.critical,
          high: formState.high,
          medium: formState.medium,
          low: formState.low,
          id: formState.id,
        };
        dispatch(saveSeveritySLAConfig(savePayload)).then((data) => {
          if (data.payload.status === 200) {
            callCommonAlert("success", data.payload.message);
            hideCommonAlert();
            addAddBodyClose();
            loadData(0, 10, getPayload());
          } else if (data?.payload?.status === 205) {
            callCommonAlert("error", data.payload.message);
            hideCommonAlert();
            // addAddBodyClose();
            // loadData(0, 10, getPayload());
          } else if (data?.payload?.status === 409) {
            callCommonAlert("warning", data.payload.message);
            hideCommonAlert();
            // addAddBodyClose();
            // loadData(0, 10, getPayload());
          } else {
            callCommonAlert(
              "error",
              "Severity SLA Configuration Failed to save"
            );
            hideCommonAlert();
          }
        });
      }
    };

    return (
      <>
        {saveSeveritySLAConfigLoading ? (
          <Spinners />
        ) : (
          <>
            <h4>
              {state?.modelRowData?.id
                ? "Update Severity SLA Configuration"
                : "Add Severity SLA Configuration"}
            </h4>

            <Row className="p-2">
              <Col xl={12} lg={12} md={12}>
                <CustomSelectDropDown
                  containerClassName={"frmgroup validate default-input"}
                  labelName={"App Criticality"}
                  isSearchable={false}
                  placeholder={"App Criticality"}
                  options={state?.appCriticalityOption || []}
                  value={state?.appCriticalityOption?.find(
                    (opt) => opt.value === formState?.appCriticality
                  )}
                  onChange={(choice) =>
                    setFormState((s) => ({
                      ...s,
                      appCriticality: choice.value,
                    }))
                  }
                  isDisabled={!!state?.modelRowData?.id}
                />
              </Col>

              <Col xl={6}>
                <FieldWithDays
                  label="Critical"
                  name="critical"
                  data-testid="criticalInput"
                  value={formState.critical}
                  onChange={(field, val) =>
                    setFormState((s) => ({
                      ...s,
                      [field]: val === "" ? "" : Number(val) || 0,
                    }))
                  }
                  error={formState.critical === "" ? formState.error : false}
                />
              </Col>

              <Col xl={6}>
                <FieldWithDays
                  label="High"
                  name="high"
                  data-testid="highInput"
                  value={formState.high}
                  onChange={(field, val) =>
                    setFormState((s) => ({
                      ...s,
                      [field]: val === "" ? "" : Number(val) || 0,
                    }))
                  }
                  error={formState.high === "" ? formState.error : false}
                />
              </Col>

              <Col xl={6}>
                <FieldWithDays
                  label="Medium"
                  name="medium"
                  data-testid="mediumInput"
                  value={formState.medium}
                  onChange={(field, val) =>
                    setFormState((s) => ({
                      ...s,
                      [field]: val === "" ? "" : Number(val) || 0,
                    }))
                  }
                  error={formState.medium === "" ? formState.error : false}
                />
              </Col>

              <Col xl={6}>
                <FieldWithDays
                  label="Low"
                  name="low"
                  data-testid="lowInput"
                  value={formState.low}
                  onChange={(field, val) =>
                    setFormState((s) => ({
                      ...s,
                      [field]: val === "" ? "" : Number(val) || 0,
                    }))
                  }
                  error={formState.low === "" ? formState.error : false}
                />
              </Col>
            </Row>

            <div className="mt-3 text-end">
              <ButtonComponent
                text="Cancel"
                className={"cancelBtnStyle btn btn-primary"}
                data-testid="cancelButton"
                onClick={addAddBodyClose}
              />
              <ButtonComponent
                text="Save"
                className={"btnStyle btn btn-primary"}
                data-testid="saveButton"
                onClick={handleSave}
              />
            </div>
          </>
        )}
      </>
    );
  };

  const addAddBodyOpen = (row) => {
    setState((prev) => ({
      ...prev,
      addBodyOpenAdd: true,
      modelRowData: row,
    }));
  };
  const addAddBody = () => {
    return <SeveritySLAForm state={state} setState={setState} />;
  };
  const addAddBodyClose = () => {
    setState((prev) => ({
      ...prev,
      addBodyOpenAdd: false,
      modelRowData: "",
    }));
  };

  const addInfoBodyOpen = (row) => {
    setState((prev) => ({
      ...prev,
      addBodyOpenInfo: true,
      modelRowData: row,
    }));
  };
  const addInfoBody = () => {
    const formatted = state?.modelRowData?.updatedOn
      ? new Date(state.modelRowData.updatedOn).toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
      : "-";

    return (
      <>
        <h4>Information</h4>
        <div className="table-responsive custom_scroll">
          <table className="table">
            <tr>
              <th>Updated By</th>
              <td>{state?.modelRowData?.updatedBy || "-"}</td>
            </tr>
            <tr>
              <th>Updated On</th>
              <td>{formatted}</td>
            </tr>
          </table>
        </div>
      </>
    );
  };
  const addInfoBodyClose = () => {
    setState((prev) => ({
      ...prev,
      addBodyOpenInfo: false,
      modelRowData: "",
    }));
  };

  return (
    <>
      <CompleteTableData
        isLoading={loading}
        data={tableData}
        columns={columns}
        TableTitle={"Severity SLA Configuration"}
        listCount={totalCount}
        pageLimit={state?.pageLimit}
        totalPageCount={Math.ceil(totalCount / 10) || 1}
        curentPageNumber={state?.pageNo}
        btnData={[
          {
            text: "Add",
            className: "solid-btn",
            disabled: false,
            function: addAddBodyOpen,
          },
        ]}
        searchKey={state?.searchKey}
        moveSearchToEnd={true}
        onPageNoChange={handlePageNoChange}
        onPageLimitChange={handlePageLimitChange}
        onSearch={onSearch}
        onSorting={handleOnSorting}
        headerSortingState={{
          accessor: state.sortByColumn,
          isDataSorted: state.sortingOrder,
        }}
      />

      <CustomModal
        modalOpen={state.addBodyOpenAdd}
        modalBody={addAddBody}
        modalHide={addAddBodyClose}
        closeBtn={true}
        closeBtnFuc={addAddBodyClose}
        size="md"
      />
      <CustomModal
        modalOpen={state.addBodyOpenInfo}
        modalBody={addInfoBody}
        modalHide={addInfoBodyClose}
        closeBtn={true}
        closeBtnFuc={addInfoBodyClose}
        size="sm"
      />

    </>
  );
};

export default memo(defaultTable);
